var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientOrgs({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3867_4625",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3867_4625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2474 18.75L14.9974 17.5L17.4974 15L14.9974 12.5L16.2474 11.25L19.9974 15L16.2474 18.75ZM6.66406 17.5V15.8333H3.33073C2.8724 15.8333 2.48003 15.6701 2.15365 15.3438C1.82726 15.0174 1.66406 14.625 1.66406 14.1667V4.16667C1.66406 3.70833 1.82726 3.31597 2.15365 2.98958C2.48003 2.66319 2.8724 2.5 3.33073 2.5H16.6641C17.1224 2.5 17.5148 2.66319 17.8411 2.98958C18.1675 3.31597 18.3307 3.70833 18.3307 4.16667V10H16.6641V4.16667H3.33073V14.1667H14.1641V15.8333H12.4974V17.5H6.66406Z",
    fill: "#135FC2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientOrgs);
export default __webpack_public_path__ + "static/media/clientOrgs.cc537e43a2f27636b2474bd1a90c8160.svg";
export { ForwardRef as ReactComponent };